import angular from "angular";
import { formatDateTime } from "../../helpers/time";
import { parseISO, isValid } from "date-fns";

// Create the amDateFormat filter
const amDateFormatFilter = () => {
  return function (date, format) {
    if (!date) {
      return "";
    }

    // Handle various input types
    let dateObj;
    const createValidDate = (date) => {
      if (typeof date === "number") {
        return new Date(date);
      }
      if (typeof date === "string") {
        const parsed = parseISO(date);
        return isValid(parsed) ? parsed : new Date(date);
      }
      return new Date(date);
    };

    dateObj = createValidDate(date);

    // Check if date is valid
    if (isNaN(dateObj.getTime())) {
      return "";
    }

    // Use the formatDateTime helper with the specified format
    return formatDateTime(dateObj, format);
  };
};

export default angular
  .module("angularMoment", [])
  .filter("amDateFormat", amDateFormatFilter);
